// Centralized company data for the application
export const COMPANIES = [
  { _id: '1', name: 'WYENFOS INFOTECH', logoUrl: null, prefix: 'WIT' },
  { _id: '2', name: 'WYENFOS GOLD AND DIAMONDS', logoUrl: null, prefix: 'WGD' },
  { _id: '3', name: 'WYENFOS ADS', logoUrl: null, prefix: 'WAD' },
  { _id: '4', name: 'WYENFOS CASH VAPASE', logoUrl: null, prefix: 'WCV' },
  { _id: '5', name: 'AYUR FOR HERBALS INDIA', logoUrl: null, prefix: 'AFH' },
  { _id: '6', name: 'WYENFOS', logoUrl: null, prefix: 'WNF' },
  { _id: '7', name: 'WYENFOS PURE DROPS', logoUrl: null, prefix: 'WPD' }
];

export const DEPARTMENTS = [
  'HR', 'IT', 'Finance', 'Marketing', 'Sales', 'Operations', 'Admin', 'Customer Service'
];
